import SignaturePad from 'signature_pad';

$(document).ready(function () {

    function resizeCanvas() {
        let ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
    }

    function prepareAspectRatio(aspectRatio) {
        if (aspectRatio === 'free') {
            return '';
        }
        aspectRatio = parseInt(aspectRatio);
        if (isNaN(aspectRatio)) {
            return 1;
        }
        return aspectRatio;
    }

    let $modal = $('#cropper-modal');
    let $signatureModal = $('#signature-cropper-modal');
    let aspectRatio = prepareAspectRatio($modal.attr('data-aspect-ratio'));
    let signatureAspectRatio = prepareAspectRatio($signatureModal.attr('data-aspect-ratio-signature'));
    let image = document.getElementById('image');
    let signatureImage = document.getElementById('signature-image');
    let cropper;


    let canvas = document.getElementById('signature-pad');
    let signaturePad = new SignaturePad(canvas, {});
    let signatureModal = $('#create-signature');

    // Open system modal for uploading file avatar
    $('.js-change-avatar-image').on('click', function () {
        $('.js-image-avatar-file').click()
    })
    // Open system modal for uploading file signature
    $('.js-download-signature-image').on('click', function () {
        $('.js-signature-input-image')[0].click();
    });

    $('.js-save-signature-image').on('click', function (event) {
        // $('.js-signature-input-image')[0].click();

        if (signaturePad.isEmpty()) {
            $('.js-signature-error').show()
        } else {
            $('.js-signature-error').hide()
            let image64 = signaturePad.toDataURL();
            $('.js-signature-preview-image').attr('src', image64)
            $('.js-signature-input-image').attr('src', image64)
            $('.js-signature-input-image-data').attr('value', image64)
            $('#create-signature').modal('hide');
            signaturePad.clear();
        }
    })
    $('.js-clear-signature').on('click', function () {
        signaturePad.clear();
    })

    //Sending signature file
    $(document).on('change', '.js-signature-input-image', function (e) {

        let files = e.target.files,
            reader,
            file,
            done = function (url) {
                signatureImage.src = url;
                $signatureModal.modal('show');
            };
        if (files && files.length > 0) {
            file = files[0];
            if (FileReader) {
                reader = new FileReader();
                reader.onload = function (e) {
                    done(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    })

    $(document).on("change", ".js-image-avatar-file", function (e) {
        let files = e.target.files,
            reader,
            file,
            done = function (url) {
                image.src = url;
                $modal.modal('show');
            };
        if (files && files.length > 0) {
            file = files[0];

            if (URL) {
                done(URL.createObjectURL(file));
            } else if (FileReader) {
                reader = new FileReader();
                reader.onload = function (e) {
                    done(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    });

    $modal.on('shown.bs.modal', function () {
        cropper = new Cropper(image, {
            aspectRatio: aspectRatio,
            viewMode: 0,
            preview: '.preview'
        });
    }).on('hidden.bs.modal', function () {
        cropper.destroy();
        cropper = null;
    });

    $signatureModal.on('shown.bs.modal', function () {
        cropper = new Cropper(signatureImage, {
            aspectRatio: signatureAspectRatio,
            viewMode: 0,
            preview: '.preview'
        });
    }).on('hidden.bs.modal', function () {
        cropper.destroy();
        cropper = null;
    });

    $("#signature-crop-modal").click(function () {
        canvas = cropper.getCroppedCanvas({
            width: 360,
            height: 360,
        });

        canvas.toBlob(function (blob) {
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
                let base64data = reader.result;

                $('.js-signature-input-image').attr('src', base64data)
                $('.js-signature-preview-image').attr('src', base64data)
                $('.js-signature-input-image-data').attr('value', base64data)

                $signatureModal.modal('hide');
            }
        });
    })
    $("#crop-modal").click(function () {
        canvas = cropper.getCroppedCanvas({
            width: 160,
            height: 160,
        });

        canvas.toBlob(function (blob) {
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
                let base64data = reader.result;
                $('.js-image-avatar-file').attr('src', base64data)
                $('.js-profile-img').attr('src', base64data)

                $modal.modal('hide');
            }
        });
    })

    $(signatureModal).on('shown.bs.modal', function () {
        window.onresize = resizeCanvas;
        resizeCanvas();
    });

});
